export const CLEAR_TOASTS = 'CLEAR_TOASTS';
export const ADD_TOAST = 'ADD_TOAST';
